import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ComplementoWebComponent } from './complemento-web.component';
import { ThemeModule } from 'src/app/@theme/theme.module';
import { GenericTableAppModule } from 'src/app/@generic-table-app/generic-table-app.module';
import { SharedModule } from 'src/app/@shared/shared.module';
import { ComplementoWebRoutingModule } from './complemento-web.routing.module';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { ConsultaPrincipalComponent } from './consulta-principal/consulta-principal.component';
import { NavSeccionesComplementoComponent } from './@components/nav-secciones-complemento/nav-secciones-complemento.component';
import { DetalleComplementoComponent } from './@components/detalle-complemento/detalle-complemento.component';
import { FormBusquedaConsultaComponent } from './@components/form-busqueda-consulta/form-busqueda-consulta.component';
import { ModalBuscarSiniestroComponent } from './@modals/modal-buscar-siniestro/modal-buscar-siniestro.component';
import { DetalleTablaCoberturasSiniestroComponent } from './@components/detalle-tabla-coberturas-siniestro/detalle-tabla-coberturas-siniestro.component';
import { DetalleConductorSiniestroComponent } from './@components/detalle-conductor-siniestro/detalle-conductor-siniestro.component';
import { DetalleSiniestroPolizaComponent } from './@components/detalle-siniestro-poliza/detalle-siniestro-poliza.component';
import { BotonesIconSeccionComponent } from './@components/botones-icon-seccion/botones-icon-seccion.component';
import { ModalVerResumenSiniestroComponent } from './@modals/modal-ver-resumen-siniestro/modal-ver-resumen-siniestro.component';
import { ModalVerConveniosComponent } from './@modals/modal-ver-convenios/modal-ver-convenios.component';
import { ListaPolizasAgentesConveniosComponent } from './@components/lista-polizas-agentes-convenios/lista-polizas-agentes-convenios.component';
import { ListaResumenSiniestroComponent } from './@components/lista-resumen-siniestro/lista-resumen-siniestro.component';
import { DetalleSiniestroResumenComponent } from './@components/detalle-siniestro-resumen/detalle-siniestro-resumen.component';
import { DetalleTablaCoberturasSiniestroResumenComponent } from './@components/detalle-tabla-coberturas-siniestro-resumen/detalle-tabla-coberturas-siniestro-resumen.component';
import { SubtituloSeccionComplementoComponent } from './@components/subtitulo-seccion-complemento/subtitulo-seccion-complemento.component';
import { DetalleTablaServiciosSiniestroResumenComponent } from './@components/detalle-tabla-servicios-siniestro-resumen/detalle-tabla-servicios-siniestro-resumen.component';
import { DetalleTablaPagosRecuperacionesResumenComponent } from './@components/detalle-tabla-pagos-recuperaciones-resumen/detalle-tabla-pagos-recuperaciones-resumen.component';
import { DetalleTablaOcupantesResumenComponent } from './@components/detalle-tabla-ocupantes-resumen/detalle-tabla-ocupantes-resumen.component';
import { DragDropMultipleFileDirective } from './@directives/drag-drop-multiple.directive';
import { CardVerDetalleDocumentoComponent } from './@components/card-ver-detalle-documento/card-ver-detalle-documento.component';
import { DragDropMultipleComplementoComponent } from './@components/drag-drop-multiple-complemento/drag-drop-multiple-complemento.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ComplementoWebEffects } from './@store/complemento-web/complemento-web.effects';
import { complementoWebReducer } from './@store/complemento-web/complemento-web.reducer';

import * as pipes from './@pipe';
import { SeccionOcupantesComponent } from './@secciones/seccion-ocupantes/seccion-ocupantes.component';
import { SeccionServiciosComponent } from './@secciones/seccion-servicios/seccion-servicios.component';
import { SeccionComplementoComponent } from './@secciones/seccion-complemento/seccion-complemento.component';
import { SeccionFotografiasComponent } from './@secciones/seccion-fotografias/seccion-fotografias.component';
import { SeccionPagosRecuperacionesComponent } from './@secciones/seccion-pagos-recuperaciones/seccion-pagos-recuperaciones.component';
import { SeccionEstimacionesSiniestroComponent } from './@secciones/seccion-estimaciones-siniestro/seccion-estimaciones-siniestro.component';
import { SeccionVerificaReglasSiniestroComponent } from './@secciones/seccion-verifica-reglas-siniestro/seccion-verifica-reglas-siniestro.component';

import { TooltipDetalleCoberturaComponent } from './@components/tooltip-detalle-cobertura/tooltip-detalle-cobertura.component';
import { TooltipDetalleCoberturaResumenComponent } from './@components/tooltip-detalle-cobertura-resumen/tooltip-detalle-cobertura-resumen.component';
import { CrearActualizaComplementoComponent } from './@components/crear-actualiza-complemento/crear-actualiza-complemento.component';
import { CrearActualizarTercerosComponent } from './@components/crear-actualizar-terceros/crear-actualizar-terceros.component';
import { CrearActualizarServiciosTerceroComponent } from './@components/crear-actualizar-servicios-tercero/crear-actualizar-servicios-tercero.component';
import { CrearActualizarServiciosAseguradoComponent } from './@components/crear-actualizar-servicios-asegurado/crear-actualizar-servicios-asegurado.component';
import { ModalConsultarVehiculosComponent } from './@modals/modal-consultar-vehiculos/modal-consultar-vehiculos.component';
import { ModalVerReferenciasSiniestroResumenComponent } from './@modals/modal-ver-referencias-siniestro-resumen/modal-ver-referencias-siniestro-resumen.component';
import { AltaTipoTercerosComponent } from './@components/alta-tipo-terceros/alta-tipo-terceros.component';
import { TablaMotivosResumenComponent } from './@components/tabla-motivos-resumen/tabla-motivos-resumen.component';
import { CrearActualizarPagosRecuperacionesComponent } from './@components/crear-actualizar-pagos-recuperaciones/crear-actualizar-pagos-recuperaciones.component';
import { CrearActualizarOcupantesAseguradoComponent } from './@components/crear-actualizar-ocupantes-asegurado/crear-actualizar-ocupantes-asegurado.component';
import { CrearActualizarOcupanteTerceroComponent } from './@components/crear-actualizar-ocupante-tercero/crear-actualizar-ocupante-tercero.component';
import { ModalConsultarLesionadosComponent } from './@modals/modal-consultar-lesionados/modal-consultar-lesionados.component';
import { ModalConsultarTercerosComponent } from './@modals/modal-consultar-terceros/modal-consultar-terceros.component';
import { FormatoNumeroMonedaCoplementoWebDirective } from './@directives/formato-numero-moneda.directiva';
import { ModalConsultaAjustadoresComponent } from './@modals/modal-consulta-ajustadores/modal-consulta-ajustadores.component';
import { DocumentosSeccionComplementoComponent } from './@components/documentos-seccion-complemento/documentos-seccion-complemento.component';
import { OcultaPaginadorPaginadorDirective } from './@directives/ocultar-elemento-paginador.directive';
import { PaginaDatosTablaComponent } from './@components/pagina-datos-tabla/pagina-datos-tabla.component';

const COMPONENTS = [
  ComplementoWebComponent,
  ConsultaPrincipalComponent,
  NavSeccionesComplementoComponent,
  PaginaDatosTablaComponent,
  DetalleComplementoComponent,
  FormBusquedaConsultaComponent,
  ModalBuscarSiniestroComponent,
  BotonesIconSeccionComponent,
  //Detalle
  DetalleTablaCoberturasSiniestroComponent,
  DetalleConductorSiniestroComponent,
  DetalleSiniestroPolizaComponent,
  ModalVerConveniosComponent,
  ListaPolizasAgentesConveniosComponent,
  ListaResumenSiniestroComponent,
  //Secciones
  SeccionComplementoComponent,
  SeccionServiciosComponent,
  SeccionPagosRecuperacionesComponent,
  SeccionOcupantesComponent,
  SeccionEstimacionesSiniestroComponent,
  SeccionFotografiasComponent,
  SeccionVerificaReglasSiniestroComponent,
  //Resumen
  ModalVerResumenSiniestroComponent,
  DetalleSiniestroResumenComponent,
  DetalleTablaCoberturasSiniestroResumenComponent,
  SubtituloSeccionComplementoComponent,
  DetalleTablaServiciosSiniestroResumenComponent,
  DetalleTablaPagosRecuperacionesResumenComponent,
  DetalleTablaOcupantesResumenComponent,

  CardVerDetalleDocumentoComponent,
  DragDropMultipleComplementoComponent,
  TooltipDetalleCoberturaComponent,
  TooltipDetalleCoberturaResumenComponent,
  CrearActualizaComplementoComponent,
  CrearActualizarTercerosComponent,
  CrearActualizarServiciosTerceroComponent,
  CrearActualizarServiciosAseguradoComponent,
  ModalConsultarVehiculosComponent,
  ModalVerReferenciasSiniestroResumenComponent,
  AltaTipoTercerosComponent,
  TablaMotivosResumenComponent,
  CrearActualizarPagosRecuperacionesComponent,
  CrearActualizarOcupantesAseguradoComponent,
  CrearActualizarOcupanteTerceroComponent,
  ModalConsultarLesionadosComponent,
  ModalConsultarTercerosComponent,
  ModalConsultaAjustadoresComponent,
  DocumentosSeccionComplementoComponent
];

const DIRECTIVES = [
  DragDropMultipleFileDirective,
  FormatoNumeroMonedaCoplementoWebDirective,
  OcultaPaginadorPaginadorDirective
];

const PIPES = [
  pipes.DescriptionAnySelectPipe,
  pipes.OrderByPropertyPipe,
  pipes.NoImagenPipe,
  pipes.SafeUrlPipe
];

@NgModule({
    imports: [
    CommonModule,
    ThemeModule,
    GenericTableAppModule,
    SharedModule,
    ComplementoWebRoutingModule,
    StoreModule.forFeature('complementoWeb', complementoWebReducer),
    EffectsModule.forFeature([ComplementoWebEffects]),
    NgxExtendedPdfViewerModule,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
],
    providers: [
        CurrencyPipe,
    ],
})
export class ComplementoWebModule { }
